import React from 'react';
import { Button, Flex, Text } from '@mantine/core';
import { useProductQuiz } from '../ProductQuizContext';
import styles from '../ProductQuiz.module.scss';
import { isMobileDevice } from '../../../lib/util/isMobileDevice';
import { useTranslation } from 'react-i18next';

export const QuestionNextButton: React.FC<{ showOnDesktop: boolean; isDisabled: boolean; event: () => void }> = ({
  showOnDesktop,
  isDisabled,
  event,
}) => {
  const { t } = useTranslation();
  const { previousQuestion, nextQuestion } = useProductQuiz();

  const isMobile = isMobileDevice();

  if (isMobile) {
    return (
      <Flex className={styles.noHighlight}>
        <Button
          w="100%"
          radius={100}
          h={56}
          className={styles.noHighlight}
          sx={(theme) => ({
            backgroundColor: isDisabled ? theme.colors['gray-400'] : 'white',
            color: isDisabled ? theme.colors['background-dark-tertiary'] : 'black',
            '&:active': {
              backgroundColor: isDisabled ? theme.colors['gray-400'] : 'white',
              transform: 'none',
            },
          })}
          onClick={() => {
            event();
            nextQuestion();
          }}
          disabled={isDisabled}
        >
          <Text size={16} py={10}>
            {t('next')}
          </Text>
        </Button>
      </Flex>
    );
  }

  if (showOnDesktop) {
    return (
      <Flex justify="center" className={styles.noHighlight} gap={24}>
        <Button
          w="25%"
          radius={100}
          h={56}
          px={32}
          py={16}
          className={styles.noHighlight}
          sx={(theme) => ({
            backgroundColor: theme.colors['background-dark-secondary'],
            color: 'white',
            borderColor: 'white',
            '&:hover': {
              backgroundColor: isDisabled ? theme.colors['background-dark-secondary'] : 'white',
              transform: 'none',
            },
            '&:active': {
              backgroundColor: isDisabled ? theme.colors['background-dark-secondary'] : 'white',
              transform: 'none',
            },
          })}
          onClick={() => {
            previousQuestion();
          }}
        >
          <Text size={16} py={10}>
            {t('back')}
          </Text>
        </Button>
        <Button
          w="100%"
          radius={100}
          h={56}
          className={styles.noHighlight}
          sx={(theme) => ({
            backgroundColor: isDisabled ? theme.colors['gray-400'] : 'white',
            color: isDisabled ? theme.colors['background-dark-tertiary'] : 'black',
            '&:hover': {
              backgroundColor: isDisabled ? theme.colors['gray-400'] : 'white',
              transform: 'none',
            },
            '&:active': {
              backgroundColor: isDisabled ? theme.colors['gray-400'] : 'white',
              transform: 'none',
            },
          })}
          onClick={() => {
            event();
            nextQuestion();
          }}
          disabled={isDisabled}
        >
          <Text size={16} py={10}>
            {t('next')}
          </Text>
        </Button>
      </Flex>
    );
  }

  return null;
};
